import React from "react";
import style from "../css/eventLiveCounter.css";

export default function eventLiveCounter(timer) {
    return (
        <div className={style.cont}>
            <div className={style.spinner}></div>
            <div className={style.number}>
                <span>{timer}</span>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/eventLiveCounter.js